export default "__VITE_ASSET__a0dfb26f__"